export default "__VITE_ASSET__2f919156__"